import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * "Where to find it?" under a read-only rejection (specs/S6-trading-account/spec.md R9,
 * `CompteLectureSeule.html`). At risk, Q38: it goes with the read-only state if the password goes.
 */
// TODO(Q38): remove with TRADING_ACCOUNT_READ_ONLY if the trader no longer enters a password.
export function ReadOnlyHelp(): ReactElement {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined" sx={{ p: 1.75, borderRadius: 3.5 }}>
      <Typography component="h2" sx={{ fontWeight: 600, fontSize: 14 }}>
        {t('onboarding.tradingAccount.readOnly.whereTitle')}
      </Typography>
      <Typography sx={{ fontSize: 13, color: 'text.secondary', lineHeight: 1.5, mt: 0.5 }}>
        {t('onboarding.tradingAccount.readOnly.whereBody')}
      </Typography>
    </Paper>
  );
}
